import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { SyncDexcomRequest } from './data-objects';

export const sync = async (data: SyncDexcomRequest) =>
  apiClient.post<SyncDexcomRequest, ApiClientResponse<SyncDexcomRequest>>(routes.dexcom.sync, data);
